<template>
  <div id="guide-section-wrapper" class="inner-container flex justify-between">
    <aside class="identity-sidebar relative flex-shrink-0 w-72 hidden md:block" :class="{ 'guide-active': true }">
      <div class="identity-sidebar-wrap pr-5">
        <div class="flex flex-col sticky top-0">
          <div
            class="flex items-center justify-between cursor-pointer font-semibold text-lg mb-2"
            @click="collapseIndex()"
          >
            <span class="text-4xl">{{ $t('Index') }}</span>
            <span class="inline-block pad-5 js-cat-arrow pointer-events-none">
              <span class="inline-block icon_triangle"></span>
            </span>
          </div>
          <div class="flex flex-col space-y-2">
            <a
              v-for="title in content.index"
              class="sidebar-index-links cursor-pointer text-md text-gray-600 dark:text-gray-300 list-none pb-2 underline"
              @click="scrollToSection(title.text)"
            >
              {{ title.text }}
            </a>
          </div>
        </div>
      </div>
    </aside>
    <div id="guide-container" class="flex-grow w-full md:w-3/4">
      <div id="things-to-do-div" class="ghost">
        <div id="things-to-do-content">
          <div>
            <div id="post_authors-title" class="font-semibold">
              {{ content.authors.length > 1 ? $t('Authors') : $t('Author') }}
            </div>
            <div class="flex items-center flex-wrap">
              <a v-for="author in sortedAuthors" :key="author.name" class="font-semibold my-4 flex items-center">
                <div class="w-10 h-10 mr-2 mb-2 flex-shrink-0">
                  <SmartImg
                    v-if="author.image"
                    class="object-cover rounded-md bg-gray-300 dark:bg-gray-600 w-full h-full"
                    :src="author.image"
                    :alt="`${author.name} profile image`"
                    sizes="20px"
                  />
                  <div v-else class="w-full h-full rounded-md bg-transparent"></div>
                </div>
                <div class="flex flex-col justify-center mr-10 text-end">
                  <NuxtLinkLocale v-if="author.url" :to="author.url" class="">{{ author.name }}</NuxtLinkLocale>
                  <NuxtLinkLocale v-else to="/about-us" class="text-gray-600 dark:text-gray-300">{{
                    author.name
                  }}</NuxtLinkLocale>
                </div>
              </a>
            </div>
          </div>
          <ReaderZone>
            <div v-processlinks id="things-to-do-description" v-html="content.guide"></div>
          </ReaderZone>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale, t } = useI18n();

const props = defineProps({
  content: {
    type: [String, Object],
    required: true,
  },
  cityDisplayName: {
    type: String,
    required: true,
  },
});

const openState = ref({});

const buttonText = (index) => {
  return openState.value[index] ? t('+ Read more') : t('+ Read more');
};

const toggleText = (index) => {
  openState.value = {
    ...openState.value,
    [index]: !openState.value[index],
  };
  const target = document.querySelector(`#guide-element-last-${index}`);
  target.classList.toggle('hidden');
};

const sortedAuthors = computed(() => {
  return [...props.content.authors].sort((a, b) => {
    if (a.url && !b.url) return -1;
    if (!a.url && b.url) return 1;
    return 0;
  });
});

const scrollToSection = (title) => {
  // Remove spaces, lowercase the string, replace spaces with -, and remove special characters
  const titleId = title
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .toLowerCase();
  const section = document.getElementById(titleId);
  window.scrollTo({
    top: section.offsetTop,
    behavior: 'smooth',
  });
};

</script>

<style scoped></style>
